import ConnectedServiceParam from '@/ecm/models/connectedService/ConnectedServiceParam';
export default class ConnectedService {
    constructor(dto) {
        this.id = 0;
        this.serviceName = '';
        this.description = '';
        this.params = [];
        this.syncParams = [];

        if (dto) {
            this.id = dto.Id;
            this.serviceName = dto.ServiceName;
            this.description = dto.Description;
            this.params = dto.Params.map(x => new ConnectedServiceParam(x));
            if (dto.SyncParams) {
                var syncParamsObj = JSON.parse(dto.SyncParams);
                this.syncParams = Object.keys(syncParamsObj).map((key) => ({
                    name: key,
                    value: syncParamsObj[key],
                }));
            }
        }
    }

    toDto() {
        var syncParamsJSON = '';
        if (this.syncParams.length > 0) {
            var syncParamsObj = {};
            this.syncParams.forEach(p => {
                syncParamsObj[p.name] = p.value;
            });
            syncParamsJSON = JSON.stringify(syncParamsObj);
        }
        return {
            Id: this.id,
            ServiceName: this.serviceName,
            Description: this.description,
            Params: this.params.map(x => x.toDto()),
            SyncParams: syncParamsJSON,
        };
    }
}
